import { EntityType } from '@frontend/common';
import { SettingFieldType, SettingValue } from '@frontend/setting/types';

import useSettingFieldInput from './setting-field-input.controller';

export interface SettingFieldInputProps {
    targetEntityType?: EntityType;
    targetEntityId?: string;
    className?: string;
    type: SettingFieldType;
    value: SettingValue;
    options?: string[];
    onChange: (value: SettingValue) => void;
    required?: boolean;
    label?: React.ReactNode | string;
    templateKey?: string;
    isClearable?: boolean;
}

/**
 * @param props
 * @returns
 */
export const SettingFieldInput = (props: SettingFieldInputProps) => {
    const viewProps = useSettingFieldInput(props);
    return viewProps.input;
};
